import { CianAnalytics } from './analytics';

// tslint:disable-next-line:no-any
(window as any).CianAnalytics = new CianAnalytics();
